import { type FC } from "react";
import type { IconButtonProps } from "@mui/material";
import { IconButton, styled } from "@mui/material";

export interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}
export const ExpandMore: FC<ExpandMoreProps> = styled(
  (props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  },
)(({ theme, expand }) => ({
  transform: !expand ? "rotate(-90deg)" : "rotate(0deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));
